import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Form, Button, Row, Col } from 'react-bootstrap';
import ModalEditUser from '../../components/ModalEdit/ModalEditUser';
import ModalChangePassword from '../../components/ModalEdit/ModalChangePassword';
import { getDataUser } from '../../services/userServices';
import { useSelector } from 'react-redux';
import './UserInfo.scss';

const UserInfo = () => {
    const user = useSelector(state => state.user);

    const [data, setData] = useState({});
    const [isShowUpdateModalUser, setIsShowUpdateModalUser] = useState(false);
    const [isShowUpdatePasswordModal, setIsShowUpdatePasswordModal] = useState(false);

    const handleToChangePasswordPage = () => {
        setIsShowUpdatePasswordModal(true);
    };

    const handleToEditPage = () => {
        setIsShowUpdateModalUser(true);
    };

    const closeEditModal = () => {
        setIsShowUpdateModalUser(false);
    };

    const closeEditPasswordModal = () => {
        setIsShowUpdatePasswordModal(false);
    };

    const formatDateDisplay = (dateString) => {
        if (!dateString) return 'Chưa cập nhật';
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return dateString;

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
    };

    const getInitialLetter = () => {
        const nameStr = data.name || data.userCode || '';
        if (!nameStr) return 'U';
        const parts = nameStr.trim().split(/\s+/);
        if (parts.length > 0) {
            const lastWord = parts[parts.length - 1];
            return lastWord.charAt(0).toUpperCase();
        }
        return nameStr.charAt(0).toUpperCase();
    };

    useEffect(() => {
        const fetchUserData = async () => {
            const rawUser = user?.userData?.userData || user?.userData || user?.account || {};
            let merged = { ...rawUser };

            const userCodeToFetch = merged.userCode || merged.username || merged.code || user?.userData?.userCode || user?.account?.userCode;

            if (userCodeToFetch) {
                try {
                    const res = await getDataUser(userCodeToFetch);
                    if (res && res.ok && res.data) {
                        merged = { ...merged, ...(res.data.userData || res.data) };
                    }
                } catch (err) {
                    console.error("Lỗi khi tải thông tin cá nhân:", err);
                }
            }

            const normalized = {
                userCode: merged.userCode || merged.username || merged.code || '',
                name: merged.name || merged.fullName || merged.username || '',
                phoneNumber: merged.phoneNumber || merged.phone || merged.mobile || '',
                email: merged.email || '',
                gender: merged.gender !== undefined ? merged.gender : true,
                dateOfBirth: merged.dateOfBirth || merged.dob || '',
                address: merged.address || '',
                role: merged.role || merged.position || '',
                groupName: merged.groupName || user.account?.groupWithRoles?.name || user.userData?.groupWithRoles?.name || '',
                avatar: merged.avatar || merged.image || ''
            };

            setData(normalized);
        };

        fetchUserData();
    }, [user]);

    const isClient = user.account?.groupWithRoles?.name === 'Client' || user.userData?.groupWithRoles?.name === 'Client';
    const classificationText = isClient ? 'Người sử dụng dịch vụ' : 'Nhân viên quản lý';

    return (
        <div className="user-profile-page">
            <Helmet>
                <title>Thông tin cá nhân | SmartPark</title>
            </Helmet>

            <div className="container py-5">
                <div className="profile-wrapper">
                    {/* Header Banner & Card */}
                    <div className="profile-header-card">
                        <div className="banner-bg"></div>
                        <div className="profile-header-content">
                            <div className="avatar-wrapper">
                                {data.avatar && !data.avatar.includes('pravatar') && !data.avatar.includes('faceAvatar') ? (
                                    <img src={data.avatar} alt="Avatar" className="user-avatar-img" />
                                ) : (
                                    <div className="user-avatar-initial">
                                        {getInitialLetter()}
                                    </div>
                                )}
                            </div>

                            <div className="user-info-meta">
                                <div className="user-title-group">
                                    <h2>{data.name || 'Người dùng SmartPark'}</h2>
                                    <div className="user-badge">
                                        <i className="bi bi-shield-check me-1"></i>
                                        <span>{classificationText}</span>
                                    </div>
                                </div>

                                <div className="action-buttons-group">
                                    <Button variant="primary" className="btn-profile-edit" onClick={handleToEditPage}>
                                        <i className="bi bi-pencil-square me-2"></i>
                                        Chỉnh sửa thông tin
                                    </Button>
                                    <Button variant="outline-secondary" className="btn-profile-pwd" onClick={handleToChangePasswordPage}>
                                        <i className="bi bi-key me-2"></i>
                                        Đổi mật khẩu
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Details Info Grid */}
                    <div className="profile-details-card">
                        <h4 className="section-title">
                            <i className="bi bi-person-lines-fill text-primary me-2"></i>
                            Chi tiết thông tin cá nhân
                        </h4>

                        <Row className="g-4">
                            {/* Column 1 */}
                            <Col md={6}>
                                <div className="info-field-box">
                                    <div className="field-icon">
                                        <i className="bi bi-person-vcard text-primary"></i>
                                    </div>
                                    <div className="field-content">
                                        <label>Mã người dùng</label>
                                        <p className="fw-bold text-primary mb-0">{data.userCode || '---'}</p>
                                    </div>
                                </div>

                                <div className="info-field-box">
                                    <div className="field-icon">
                                        <i className="bi bi-person text-success"></i>
                                    </div>
                                    <div className="field-content">
                                        <label>Họ và tên</label>
                                        <p className="mb-0">{data.name || '---'}</p>
                                    </div>
                                </div>

                                <div className="info-field-box">
                                    <div className="field-icon">
                                        <i className="bi bi-telephone text-info"></i>
                                    </div>
                                    <div className="field-content">
                                        <label>Số điện thoại</label>
                                        <p className="mb-0">{data.phoneNumber || '---'}</p>
                                    </div>
                                </div>

                                <div className="info-field-box">
                                    <div className="field-icon">
                                        <i className="bi bi-envelope text-warning"></i>
                                    </div>
                                    <div className="field-content">
                                        <label>Email liên hệ</label>
                                        <p className="mb-0">{data.email || '---'}</p>
                                    </div>
                                </div>
                            </Col>

                            {/* Column 2 */}
                            <Col md={6}>
                                <div className="info-field-box">
                                    <div className="field-icon">
                                        <i className="bi bi-gender-ambiguous text-danger"></i>
                                    </div>
                                    <div className="field-content">
                                        <label>Giới tính</label>
                                        <p className="mb-0">{data.gender ? 'Nam' : 'Nữ'}</p>
                                    </div>
                                </div>

                                <div className="info-field-box">
                                    <div className="field-icon">
                                        <i className="bi bi-calendar-event text-secondary"></i>
                                    </div>
                                    <div className="field-content">
                                        <label>Ngày sinh</label>
                                        <p className="mb-0">{formatDateDisplay(data.dateOfBirth)}</p>
                                    </div>
                                </div>

                                <div className="info-field-box">
                                    <div className="field-icon">
                                        <i className="bi bi-geo-alt text-primary"></i>
                                    </div>
                                    <div className="field-content">
                                        <label>Địa chỉ thường trú</label>
                                        <p className="mb-0">{data.address || '---'}</p>
                                    </div>
                                </div>

                            </Col>
                        </Row>
                    </div>
                </div>
            </div>

            <ModalEditUser
                isShow={isShowUpdateModalUser}
                onClose={closeEditModal}
                dataModalUserUpdate={data}
            />

            <ModalChangePassword
                isShow={isShowUpdatePasswordModal}
                onClose={closeEditPasswordModal}
                dataModalUserUpdate={data}
            />
        </div>
    );
};

export default UserInfo;
